module.exports = __webpack_public_path__ + "img/desktop/Background/background@3x.jpg?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Background/background@3x.jpg
// module id = 547
// module chunks = 0